import { Component, Event, EventEmitter, Listen, Prop, State, h } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { objectHasValues, ErrorHelper } from '../../../helpers';
import { updateLeaseApplication } from '../../../utils';
import { ContactInfoTranslation } from '../../../globals/translations';

type ContactInfo = Pick<Customer, 'email' | 'phone' | 'preference'>;

@Component({
  tag: 'contact-info-state',
  styleUrl: './state-styles/contact-info-state.scss',
  shadow: false,
})
export class ContactInfoState {
  @State() isLoading = false;

  @Prop({ mutable: true }) contactInfo: Customer;
  @Prop({ mutable: true }) errors: ErrorHelper;
  @Prop() translation: Partial<ContactInfoTranslation>;

  @Event() updateCustomer: EventEmitter<ContactInfo>;
  @Event() continueClick: EventEmitter;

  @Listen('updateContactInfo', { target: 'body' })
  async getUpdatedInfo(event: CustomEvent) {
    if (event.detail) {
      const toUpdate = { email: this.contactInfo.email, phone: this.contactInfo.phone, preference: this.contactInfo.preference } as ContactInfo;

      const { email, phone, marketingAgree } = event.detail;

      if (email !== this.contactInfo.email) {
        toUpdate.email = email;
        this.contactInfo.email = email;
      }

      if (phone !== this.contactInfo.phone) {
        toUpdate.phone = phone;
        this.contactInfo.phone = phone;
      }

      if (marketingAgree !== this.contactInfo.preference.optInToMarketing) {
        toUpdate.preference.optInToMarketing = marketingAgree;
        this.contactInfo.preference.optInToMarketing = marketingAgree;
      }

      if (objectHasValues(this.contactInfo)) {
        try {
          this.isLoading = true;
          await updateLeaseApplication({ ...toUpdate, phone: toUpdate.phone?.replace(/[^+\d]+/g, '') });
          this.updateCustomer.emit({ ...this.contactInfo });
          this.continueClick.emit();
        } catch (error) {
          this.errors.hasGenericError = true;
        }
        this.isLoading = false;
      }
    }
  }

  render() {
    return (
      <pc-contact-info {...this.contactInfo} marketingAgree={this.contactInfo.preference.optInToMarketing} isLoading={this.isLoading} translation={this.translation}>
        {this.errors.hasGenericError && <pc-generic-error slot="error-card" />}
      </pc-contact-info>
    );
  }
}
